/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".card-subtitle[_ngcontent-%COMP%]{margin-left:.5rem;font-weight:400;opacity:.8}.stale[_ngcontent-%COMP%]{color:#fdd008}.outcome[_ngcontent-%COMP%]{margin-left:.3rem;opacity:.8}.outcome-error[_ngcontent-%COMP%]{display:block;color:#f54f47}.table-compact[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-compact[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding-top:.2rem;padding-bottom:.2rem}"];
export { styles as styles };

